import { useState } from "react";
import { IGlobalNotification } from "@/common/services/types";
import { InfoBar } from "./InfoBar";
import { metricsBus } from "@/common/buses";
import { useUserStore } from "@/common/store/userStore";
import { setLastSeenNotification } from "@/common/utils/storage";
import { useAppStore } from "@/common/store";
import { apiMain } from "@/common/services";
import { useGlobalNotification } from "./hooks/useGlobalNotification";

declare global {
  interface Window {
    notifications: {
      global?: {
        anonymous?: IGlobalNotification[];
        verified?: IGlobalNotification[];
        unverified?: IGlobalNotification[];
      };
    };
  }
}

export const InfoBarContainer = () => {
  const { username } = useUserStore((state) => state.currentUser);
  const isV2Variant = useAppStore((state) => state.isV2Variant);
  const [showNotify, setShowNotify] = useState<boolean>(true);
  const { notification } = useGlobalNotification();

  const sendDeleteNotification = async (id: string) => {
    try {
      await apiMain.deleteGlobalNotification(id);
    } catch (err) {
      console.error(err);
    }
  };

  const onLinkAction = async (id: string) => {
    metricsBus.emit("infoBarClicked");
    setLastSeenNotification(id);

    if (username) {
      await sendDeleteNotification(id);
    }

    setShowNotify(false);
  };

  const onCloseInfoBar = (id: string) => {
    metricsBus.emit("infoBarClosed");
    setShowNotify(false);
    setLastSeenNotification(id);

    if (username) {
      sendDeleteNotification(id);
    }
  };

  if (
    isV2Variant ||
    !notification
  ) {
    return null;
  }

  return (
    <InfoBar
      showNotify={showNotify}
      onLinkAction={onLinkAction}
      onCloseInfoBar={onCloseInfoBar}
      notification={notification}
    />
  );
};

export default InfoBarContainer;
